<!-- 批量下载pdf面单 -->
<template>
<div class="page-box">
    <ctrl-box class="ctrl-box" :data="{}">
        <template>
            <div class="xgroup">
                <el-link :underline="false" @click="() => visible = true">
                    <div class="wrap" >
                        <icon-svg icon-class="icon-kuaishuchajian" font-size="27px;"/>
                        <span class="txt" >{{msg('查询进度')}}</span>      
                    </div>                
                </el-link>
            </div>
        </template>
    </ctrl-box>
    <div style="padding: 20px;">
        <el-alert v-if="resultMsg"  :title="resultMsg" type="success" show-icon
        :description="detailMsg"
        ></el-alert>
    </div>
    <div style="padding: 0 20px 20px 20px;">
        <el-input type="textarea" :placeholder="msg('输入单号，一行一个单号，或者一个逗号一个')"
            v-model="codes" rows="20">
        </el-input>
    </div>
    <div v-if="submited" style="text-align:center; margin-top: 15px;">
        <el-button type="primary" size="mini"  @click="onSubmit()">
            <i class="el-icon-check"></i><span>{{msg('提交下载任务')}}</span>
        </el-button>
    </div>

    <el-dialog :title="msg('查看结果')" :visible.sync="visible"
        :fullscreen="isMinScreen"
        :close-on-click-modal="false" 
        width="60%"
    >
        <div>
            <el-input type="input" :placeholder="msg('输入任务名进行查询')"
                v-model="taskName" 
            >
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </el-input>
            <div v-if="texts && texts.length>0" style="padding-top: 15px;">
                <el-alert :type="resultType" show-icon>
                <div slot="title">
                    <div v-for="text in texts" :key="text">{{ text }}</div>
                </div>
            </el-alert>
            </div>
            <div style="text-align:center; padding-top: 15px;">
                <el-button type="warning" size="mini"  @click="onContinue()">
                    <i class="el-icon-magic-stick"></i><span>{{msg('继续处理任务')}}</span>
                </el-button>
                <el-button v-if="showDownder"  type="primary" size="mini"  @click="onDownlod()">
                    <i class="el-icon-download"></i><span>{{msg('下载')}}</span>
                </el-button>
            </div>
        </div>
    </el-dialog>

</div>
</template>
<script>
import CtrlBox from "../../components/CtrlBox.vue";
export default {
    name: "BatchDownExportExpressPage",
    components:{
        CtrlBox: CtrlBox,
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        }
    },
    data(){
        return {
            codes: null,
            taskName: null,
            submited: true,
            visible: false,
            showDownder: false,
            texts: null,
            resultMsg: null,
            resultType: null,
            detailMsg: "请牢记任务号，如果丢失将会自动不能下载此次提交结果",
            type: "success",
        }
    },
    methods: {
        onSubmit() {
            if(!this.codes || this.codes.length == 0){
                this.$message(this.msg("没有待提交的数据"));
                return;
            }

            let cs = this.codes.split(/[\s,，]+/);

            let doSubmit = async () => {
                let result = await this.$axios.post(this.$kit.api.export.addExportTask, cs)
                if(result.status){
                    this.submited = false;
                    this.resultMsg = "提交成功，任务号："+result.data;
                    this.detailMsg = "请牢记任务号，如果丢失将会自动不能下载此次提交结果";
                }else{
                    this.resultMsg = this.msg(result.msg);
                    this.detailMsg = "";
                }
            }
            doSubmit();
            
        },
        onSearch(){
            if(!this.taskName || this.taskName.split("-").length!=3){
                this.$message(this.msg("任务名为不正确"));
                return;
            }
            
            let doSearch = async () => {
                let result = await this.$axios.get(this.$kit.api.export.searchProgress+"?tn="+encodeURIComponent(this.taskName));
                if(result.status){
                    this.resultType = "success";
                    this.texts = result.data.split(/\n/);
                    if(this.texts[this.texts.length-1].indexOf('状态:完成')>-1){
                        this.showDownder = true;
                    }else{
                        this.showDownder = false;
                    }
                }else{
                    this.resultType = "error";
                    if(result.msg.indexOf("NoSuchFileException")>-1){
                        this.texts = ["任务不存在"];
                    }else{
                        this.texts = [result.msg]
                    }
                }
            }
            doSearch();

        },
        onContinue(){
            if(!this.taskName || this.taskName.split("-").length!=3){
                this.$message(this.msg("任务名为不正确"));
                return;
            }
            
            let doContinue = async () => {
                let result = await this.$axios.get(this.$kit.api.export.continueProcess+"?tn="+encodeURIComponent(this.taskName));
                if(result.status){
                    this.$message(result.msg);
                }else{
                    this.$message({
                        type: 'warning',
                        message: result.msg
                    });  
                }
            }
            doContinue();

        },
        onDownlod(){
            window.location.href=this.$kit.api.export.downloadPage+"?tn="+encodeURIComponent(this.taskName);
        }
    }
} 

</script>
